import globalStyle from '@/styles/Global.scss'

const MButton = ({ value = '',
                   width = 120,
                   disabled = false,
                   color = 'white',
                   fontColor = '#0a58ca',
                   image = '',
                   onClick = () => {} },
                   preventDefault = true) => {
  const click = (e) => {
    if (preventDefault) {
      e.preventDefault()
    }
    onClick()
  }

  return (
    <>
      <button
        className={globalStyle.navigateButton}
        style={{ width: `${width}px` }}
        disabled={disabled}
        onClick={click}
      >
        {
          image !== '' && <>
            <img width={`${width}px`} src={`/button/${image}`}/>
          </>
        }
        {
          image === '' && <>
            <span style={{color: fontColor}}>{value}</span>
          </>
        }
      </button>
    </>
  )
}

export default MButton;
